// extracted by css-extract-rspack-plugin
export default {"messageStatus":"messageStatus-xn9KZv","sendingSpinner":"sendingSpinner-S43GbR"};